/**
 * Clear focus from page chrome (e.g. sidebar) before opening a MUI modal.
 * Prevents "Blocked aria-hidden on #root" when focus stayed on a nav item.
 */
export function blurFocusOutsideDialogs() {
  const active = document.activeElement
  if (!(active instanceof HTMLElement)) return
  if (active.closest('[role="dialog"]')) return
  active.blur()
}
